// extracted by mini-css-extract-plugin
module.exports = {"c16livxw":"c16livxw","f13s2g25":"f13s2g25","itv81cu":"itv81cu"};